export default __webpack_public_path__ + "static/media/mtn.e796a348.jpeg";